import { Edit, ShowButton, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";

const EditCampaigns = () => {
  return (
    <Edit
      title="Редактиране на кампания"
      actions={
        <BackButtonToolbar
          additionalButton={
            <ShowButton
              variant="contained"
              size="medium"
            />
          }
        />
      }
      transform={data => {
        const { examIds, ...rest } = data;

        return {
          ...rest,

          exams:
            data.exams?.map(exam => ({
              ...exam,

              slot: {
                ...exam.slot,

                date: exam.slot?.date?.split("T")[0] || null,
                time: exam.slot?.time?.split("T")[1] || null,
              },
            })) || [],
        };
      }}
      mutationMode="pessimistic"
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm isEdit={true} />
      </SimpleForm>
    </Edit>
  );
};

export default EditCampaigns;
